import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Deutsch,
  English,
  Español,
  Français,
  Português,
  简体中文,
} from "../../../Constant";
import styles from "./Language.module.scss";

const LANGUAGES = [
  { code: "en", flag: "us", label: English, suffix: "(US)" },
  { code: "du", flag: "de", label: Deutsch },
  { code: "es", flag: "es", label: Español },
  { code: "fr", flag: "fr", label: Français },
  { code: "pt", flag: "pt", label: Português, suffix: "(BR)" },
  { code: "cn", flag: "cn", label: 简体中文 },
  { code: "ae", flag: "ae", label: "العربية", suffix: "(ae)" },
];

const Language = ({ className = "" }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("en");
  const wrapperRef = useRef(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!open) return undefined;
    const onPointer = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onPointer);
    return () => document.removeEventListener("mousedown", onPointer);
  }, [open]);

  const choose = (code) => {
    i18n.changeLanguage(code);
    setSelected(code);
    setOpen(false);
  };

  const currentFlag =
    selected === "en" ? "us" : selected === "du" ? "de" : selected;

  return (
    <li className={`${styles.languageNav} ${className}`.trim()}>
      <div className={styles.translate} ref={wrapperRef}>
        <div
          className={styles.current}
          onClick={() => setOpen((v) => !v)}
          aria-haspopup="listbox"
          aria-expanded={open}
        >
          <i className={`flag-icon flag-icon-${currentFlag}`} />
          <span className={styles["lang-txt"]}>{selected}</span>
        </div>

        <div
          className={`${styles.menu} ${open ? styles.active : ""}`}
          role="listbox"
        >
          {LANGUAGES.map(({ code, flag, label, suffix }) => (
            <div
              key={code}
              className={styles.lang}
              role="option"
              aria-selected={selected === code}
              onClick={() => choose(code)}
            >
              <i className={`flag-icon flag-icon-${flag}`} />
              <span className={styles["lang-txt"]}>
                {label}
                {suffix ? <span>{suffix}</span> : null}
              </span>
            </div>
          ))}
        </div>
      </div>
    </li>
  );
};

export default Language;
